import PropTypes from "prop-types";

const Print = ({ children }) => {
  return (
      <div id="print">
        <div>
          <div>
            <div>{children}</div>
          </div>
        </div>
      </div>
  );
};

export default Print;

Print.propTypes = {
  children: PropTypes.node,
};
